import React from 'react';
import { motion } from 'framer-motion';
const banks = [{
  name: 'Banca Transilvania',
  domain: 'bancatransilvania.ro'
}, {
  name: 'BCR',
  domain: 'bcr.ro'
}, {
  name: 'BRD',
  domain: 'brd.ro'
}, {
  name: 'ING Bank',
  domain: 'ing.ro'
}, {
  name: 'Raiffeisen Bank',
  domain: 'raiffeisen.ro'
}, {
  name: 'CEC Bank',
  domain: 'cec.ro'
}, {
  name: 'UniCredit Bank',
  domain: 'unicredit.ro'
}, {
  name: 'Exim Banca Românească',
  domain: 'eximbank.ro'
}, {
  name: 'Alpha Bank',
  domain: 'alphabank.ro'
}, {
  name: 'Garanti BBVA',
  domain: 'garantibbva.ro'
}, {
  name: 'Libra Internet Bank',
  domain: 'librabank.ro'
}, {
  name: 'Intesa Sanpaolo Bank',
  domain: 'intesasanpaolobank.ro'
}];
// Duplicate the list to ensure seamless looping
const marqueeBanks = [...banks, ...banks];
export function Partners() {
  return <section className="py-16 border-b border-slate-100 bg-white overflow-hidden" data-id="element-156">
      <div className="container mx-auto px-4 md:px-6 mb-10" data-id="element-157">
        <p className="text-center text-sm font-bold text-slate-400 uppercase tracking-widest" data-id="element-158">
          Parteneri Financiari de Încredere
        </p>
      </div>

      <div className="relative w-full" data-id="element-159">
        {/* Gradient Masks for smooth fade edges */}
        <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-white to-transparent z-10" data-id="element-160" />
        <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-white to-transparent z-10" data-id="element-161" />

        <div className="flex overflow-hidden" data-id="element-162">
          <motion.div className="flex gap-12 items-center px-4" animate={{
          x: ['0%', '-50%']
        }} transition={{
          x: {
            repeat: Infinity,
            repeatType: 'loop',
            duration: 40,
            ease: 'linear'
          }
        }} data-id="element-163">
            {marqueeBanks.map((bank, index) => <div key={`${bank.name}-${index}`} className="flex items-center justify-center min-w-[160px] grayscale hover:grayscale-0 transition-all duration-300 opacity-60 hover:opacity-100" data-id="element-164">
                {/* Fallback to text if image fails, but try logo first */}
                <div className="flex flex-col items-center gap-3" data-id="element-165">
                  <img src={`https://logo.clearbit.com/${bank.domain}?size=80`} alt={`${bank.name} logo`} className="h-10 object-contain max-w-[140px]" onError={e => {
                e.currentTarget.style.display = 'none';
                e.currentTarget.nextElementSibling?.classList.remove('hidden');
              }} data-id="element-166" />
                  <span className="hidden text-sm font-bold text-slate-700 whitespace-nowrap" data-id="element-167">
                    {bank.name}
                  </span>
                </div>
              </div>)}
          </motion.div>
        </div>
      </div>
    </section>;
}